import {
  useContext, useEffect, useState,
} from 'react';
import useFetch from 'use-http';
import { useLocation, useNavigate } from 'react-router';
import { Typography } from '@mui/material';
import AppContext from './App.context';
import {
  Dialog, Button, DialogActions, DialogContent,
} from '../designSystem';

function getCookie(cookieName) {
  const cookie = {};
  document.cookie.split(';').forEach((el) => {
    const [key, value] = el.split('=');
    cookie[key.trim()] = value;
  });
  return cookie[cookieName];
}

export const PasswordExpiration = () => {
  const {
    t, adminProperties, globalSettingsLoaded,
  } = useContext(AppContext);
  const location = useLocation();
  const [expireDays, setExpireDays] = useState(0);
  const navigate = useNavigate();
  const [expireDaysStringInLanguage, setExpireDaysStringInLanguage] = useState('');
  const isProfileSettingsPage = !!location.pathname.includes('profilesettings');
  const { post, cache } = useFetch('/webcast/webapi/eliteAdmin/passwordExpiredCheck', {});

  const checkPasswordExpiration = async () => {
    await post({});
    const pwdExpiringCookie = getCookie('passwordWillExpire');
    if (pwdExpiringCookie) {
      const days = window.atob(pwdExpiringCookie);
      setExpireDays(days);
      if (adminProperties?.adminProperties?.adminLanguage === 'en') {
        setExpireDaysStringInLanguage(days > 1 ? `${days} days ` : '1 day ');
      } else {
        setExpireDaysStringInLanguage(days);
      }
    }
    cache.clear();
  };

  useEffect(() => {
    if (globalSettingsLoaded && localStorage.getItem('PRE-X-ON24-CSRF-TOKEN') !== localStorage.getItem('X-ON24-CSRF-TOKEN') && !isProfileSettingsPage) {
      checkPasswordExpiration();
      localStorage.setItem('PRE-X-ON24-CSRF-TOKEN', localStorage.getItem('X-ON24-CSRF-TOKEN'));
    }
  }, [globalSettingsLoaded, isProfileSettingsPage]);

  const handleNotNowClick = () => {
    setExpireDays(0);
  };
  const handleYesClick = () => {
    setExpireDays(0);
    navigate('/webcast/profilesettings');
  };
  const closeDialog = () => {
    setExpireDays(0);
  };

  return (
    <Dialog
      title={t('PasswordExpirationNotice')}
      disableEscapeKeyDown
      show={expireDays > 0}
      aria-labelledby="PasswordExpirationNotice"
      titleId="PasswordExpirationNotice"
      maxWidth="xs"
      onClose={closeDialog}
    >
      <DialogContent>
        <Typography>{t('PasswordExpiration', { expireDaysStringInLanguage })}</Typography>
      </DialogContent>
      <DialogActions align="right">
        <Button onClick={handleNotNowClick} variant="secondary">{t('NotNow')}</Button>
        <Button onClick={handleYesClick}>{t('Yes')}</Button>
      </DialogActions>
    </Dialog>
  );
};
